/**
 * @packageDocumentation
 * @module DaVinci_API
 */

export enum INTERCEPTOR_TIMEOUT_ACTION {
  CANCEL = 'CANCEL',
  PROCEED_WITH_ORIGINAL = 'PROCEED_WITH_ORIGINAL'
}
